import React from "react";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { BsArrowRight } from "react-icons/bs";
import { BASE_ASSETS_URL } from "../../../constants/constants";
import { CLMLinkPrimaryArrow } from "components/CLM/v3/Buttons";
import CtaOne from "@components/CTA/CtaOne";

const comparisonsData = [
  {
    id: 1,
    title: "DocuSign alternatives",
    description:
      "Explore top alternatives to the popular eSignature solution, DocuSign.",
    image: "/thumbnail1.png",
    localImage: "/thumbnail1.png",
    link: "/docusign-alternatives",
    bgColor: "bg-rose-100/75",
  },
  {
    title: "DocuSign vs BoloSign",
    description:
      "Comparison of DocuSign and BoloSign for electronic signatures.",
    image: "/thumbnail2.png",
    localImage: "/thumbnail2.png",
    link: "/docusign-vs-bolosign",
    bgColor: "bg-green-100/75",
  },
  {
    title: "BoloSign vs Adobe Sign",
    description: "BoloSign and Adobe Sign feature and pricing comparison.",
    image: "/thumbnail6.png",
    localImage: "/thumbnail6.png",
    link: "/bolosign-vs-adobe-sign",
    bgColor: "bg-yellow-100/75",
  },
  {
    title: "BoloSign vs Dropbox Sign",
    description: "Evaluating BoloSign versus Dropbox Sign for digital signing.",
    image: "/thumbnail7.png",
    localImage: "/thumbnail7.png",
    link: "/bolosign-vs-dropbox-sign",
    bgColor: "bg-lime-100/75",
  },
  {
    title: "BoloSign vs HelloSign",
    description:
      "BoloSign and HelloSign comparison for electronic document signing.",
    image: "/thumbnail5.png",
    localImage: "/thumbnail5.png",
    link: "/bolosign-vs-hellosign",
    bgColor: "bg-orange-100/75",
  },
  {
    title: "BoloSign vs Pandadoc",
    description:
      "BoloSign and Pandadoc comparison for contract management solutions.",
    image: "/thumbnail3.png",
    localImage: "/thumbnail3.png",
    link: "/bolosign-vs-pandadoc",
    bgColor: "bg-green-100/75",
  },
  {
    title: "BoloSign vs Signeasy",
    description: "Compare BoloSign and Signeasy for simple document signing.",
    image: "/thumbnail8.png",
    localImage: "/thumbnail8.png",
    link: "/bolosign-vs-signeasy",
    bgColor: "bg-yellow-100/75",
  },
  {
    title: "BoloSign vs Signwell",
    description:
      "Detailed comparison between BoloSign and Signwell for signatures.",
    image: "/thumbnail4.png",
    localImage: "/thumbnail4.png",
    link: "/bolosign-vs-signwell",
    bgColor: "bg-rose-100/75",
  },
  {
    title: "BoloSign vs Zoho Sign",
    description: "Compare BoloSign and Zoho Sign for business use.",
    image: "/thumbnail9.png",
    localImage: "/thumbnail9.png",
    link: "/bolosign-vs-zoho-sign",
    bgColor: "bg-lime-100/75",
  },
  {
    id: 2,
    title: "DocuSign vs Zoho Sign",
    description:
      "E-Signature Showdown: DocuSign vs. Zoho Sign - Making the Right Choice for Your Business",
    image: "/thumbnail15.png",
    localImage: "/thumbnail15.png",
    link: "/docusign-vs-zoho-sign",
    bgColor: "bg-green-100/75",
  },
  {
    id: 3,
    title: "DocuSign vs SignWell",
    description:
      "DocuSign or SignWell: Which E-Signature Solution Is Right for Your Business?",
    image: "/thumbnail13.png",
    localImage: "/thumbnail13.png",
    link: "/docusign-vs-signwell",
    bgColor: "bg-yellow-100/75",
  },
  {
    id: 4,
    title: "DocuSign vs Pandadoc",
    description:
      "Selecting the Ideal eSignature Solution for Small Businesses: DocuSign vs. PandaDoc Comparison",
    image: "/thumbnail10.png",
    localImage: "/thumbnail10.png",
    link: "/docusign-vs-pandadoc",
    bgColor: "bg-lime-100/75",
  },
  {
    id: 5,
    title: "DocuSign vs Signeasy",
    description:
      "Signeasy offers an alternative e-signature solution with a focus on simplicity and ease of use.",
    image: "/thumbnail14.png",
    localImage: "/thumbnail14.png",
    link: "/docusign-vs-signeasy",
    bgColor: "bg-orange-100/75",
  },
  {
    id: 6,
    title: "DocuSign vs Adobe Sign",
    description:
      "Comparing DocuSign and Adobe Sign for Small Businesses: A Comprehensive Analysis.",
    image: "/thumbnail21.png",
    localImage: "/thumbnail21.png",
    link: "/docusign-vs-adobe-sign",
    bgColor: "bg-green-100/75",
  },
  {
    id: 7,
    title: "Adobe Sign vs SignWell",
    description:
      "Adobe Sign vs. SignWell: Which E-Signature Tool Should You Choose?",
    image: "/thumbnail18.png",
    localImage: "/thumbnail18.png",
    link: "/adobe-sign-vs-signwell",
    bgColor: "bg-yellow-100/75",
  },
  {
    id: 8,
    title: "Adobe Sign vs PandaDoc",
    description:
      "Adobe Sign vs. PandaDoc: Finding the Perfect Fit for Your Business.",
    image: "/thumbnail19.png",
    localImage: "/thumbnail19.png",
    link: "/adobe-sign-vs-pandadoc",
    bgColor: "bg-gray-100/75",
  },
  {
    id: 9,
    title: "Adobe Sign vs Zoho Sign",
    description:
      "Adobe Sign vs. Zoho Sign - Picking the Perfect E-Signature Partner For Your Business",
    image: "/thumbnail16.png",
    localImage: "/thumbnail16.png",
    link: "/adobe-sign-vs-zoho-sign",
    bgColor: "bg-rose-100/75",
  },
  {
    id: 10,
    title: "Adobe Sign vs Dropbox Sign",
    description:
      "Navigating the Digital Revolution: Adobe Sign vs. Dropbox Sign - Choosing Your Electronic Signature Solution",
    image: "/thumbnail20.png",
    localImage: "/thumbnail20.png",
    link: "/adobe-sign-vs-dropbox-sign",
    bgColor: "bg-cyan-100/75",
  },
  {
    id: 11,
    title: "Adobe Acrobat Sign vs Signeasy",
    description:
      "Adobe Acrobat Sign vs. SignEasy: Choosing the Right E-Signature Solution For Your Small Business.",
    image: "/thumbnail17.png",
    localImage: "/thumbnail17.png",
    link: "/adobe-acrobat-sign-vs-signeasy",
    bgColor: "bg-gray-100/75",
  },
  {
    id: 12,
    title: "Dropbox Sign vs DocuSign",
    description:
      "A Comprehensive Comparison of Dropbox Sign and DocuSign: Which E-Signature Solution Fits Your Needs?",
    image: "/thumbnail11.png",
    localImage: "/thumbnail11.png",
    link: "/dropbox-sign-vs-docusign",
    bgColor: "bg-yellow-100/75",
  },
];

const Alternatives = () => {
  return (
    <div className="mt-8 md:mt-20">
      <Head>
        <meta charSet="utf-8" />
        <title>Signature Comparisons & Alternatives | BoloSign</title>
        <meta
          name="description"
          content="Explore our comprehensive comparisons and alternatives to various eSignature solutions. Make an informed decision that best suits your business needs."
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloSign" />
        <meta
          name="keywords"
          content="esignature comparisons, esignature alternatives,e-signature comparisons, e-signature alternatives, adobe acrobat sign, signeasy, adobe acrobat sign vs signeasy, adobe acrobat sign vs signeasy comparison, adobe acrobat sign vs signeasy alternatives, adobe acrobat sign vs signeasy pricing, adobe acrobat sign vs signeasy features, adobe acrobat sign vs signeasy review, adobe acrobat sign vs signeasy pros and cons, adobe acrobat sign vs signeasy cons and pros, adobe acrobat sign vs signeasy comparison in india, adobe acrobat sign vs signeasy comparison in usa, adobe acrobat sign vs dropbox sign, adobe acrobat sign vs dropbox sign comparison, adobe acrobat sign vs dropbox sign alternatives, adobe acrobat sign vs dropbox sign pricing, adobe acrobat sign vs dropbox sign features, adobe acrobat sign vs dropbox sign review, adobe acrobat sign vs dropbox sign pros and cons, adobe acrobat sign vs dropbox sign cons and pros, adobe acrobat sign vs dropbox sign comparison in india, adobe acrobat sign vs dropbox sign comparison in usa, adobe sign vs pandadoc, adobe sign vs pandadoc comparison, adobe sign vs pandadoc alternatives, adobe sign vs pandadoc pricing, adobe sign vs pandadoc features, adobe sign vs pandadoc review, adobe sign vs pandadoc pros and cons, adobe sign vs pandadoc cons and pros, adobe sign vs pandadoc comparison in india, adobe sign vs pandadoc comparison in usa, adobe sign vs zoho sign, adobe sign vs zoho sign comparison, adobe sign vs zoho sign alternatives, adobe sign vs zoho sign pricing, adobe sign vs zoho sign features, adobe sign vs zoho sign review, adobe sign vs zoho sign pros and cons, adobe sign vs zoho sign cons and pros, adobe sign vs zoho sign comparison in india, adobe sign vs zoho sign comparison in usa, adobe sign vs docusign, adobe sign vs docusign comparison, adobe sign vs docusign alternatives, adobe sign vs docusign pricing, adobe sign vs docusign features, adobe sign vs docusign review, adobe sign vs docusign pros and cons, adobe sign vs docusign cons and pros, adobe sign vs docusign comparison in india, adobe sign vs docusign comparison in usa, adobe sign vs dropbox sign, adobe sign vs dropbox sign comparison, adobe sign vs dropbox sign alternatives, adobe sign vs dropbox sign pricing, adobe sign vs dropbox sign features, adobe sign vs dropbox sign review, adobe sign vs dropbox sign pros and cons, adobe sign vs dropbox sign cons and pros, adobe sign vs dropbox sign comparison in india, adobe sign vs dropbox sign comparison in usa, adobe acrobat sign vs signeasy, adobe acrobat sign vs signeasy comparison, adobe acrobat sign vs signeasy alternatives, adobe acrobat sign vs signeasy pricing, adobe acrobat sign vs signeasy features, adobe acrobat sign vs signeasy review, adobe acrobat sign vs signeasy pros and cons, adobe acrobat sign vs signeasy cons and pros, adobe acrobat sign vs signeasy comparison in india, adobe acrobat sign vs signeasy comparison in usa, adobe acrobat sign vs docusign, docusign alternatives, docusign vs zoho sign, docusign vs signwell, docusign vs pandadoc, docusign vs signeasy, docusign vs adobe sign, adobe sign vs signwell, adobe sign vs pandadoc, adobe sign vs zoho sign, adobe sign vs dropbox sign, adobe acrobat sign vs signeasy, adobe acrobat sign vs dropbox sign, dropbox sign vs docusign, dropbox sign vs adobe sign, dropbox sign vs signeasy, dropbox sign vs pandadoc, dropbox sign vs zoho sign, dropbox sign vs signwell, dropbox sign vs adobe, signature, e-signature, e-signature solution, e-signature software, e-signature app, e-signature tool, e-signature platform, e-signature service"
        />
        <meta
          property="og:url"
          content="https://www.bolosign.com/signature/alternatives/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Signature Comparisons & Alternatives | BoloSign"
        />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/signature/alternatives/"
        />
        <meta
          name="twitter:title"
          content="Signature Comparisons & Alternatives | BoloSign"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@boloforms" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta name="twitter:description" content="" />
        <meta property="og:description" content="" />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/alternatives/"
        />
      </Head>
      <div className="w-full">
        <div className="mx-auto max-w-[1000px] text-center md:px-8 px-4">
          <CtaOne
            heading1={"Comparisons & Alternatives"}
            paragraph={
              " Explore our comprehensive comparisons andalternatives to various eSignature solutions. Make an informed decision that best suits your            business needs."
            }
          />
        </div>
        <div className="text-gray-600 body-font  md:px-8 px-4 max-w-screen-xl mx-auto">
          <div className="w-full max-w-screen-mxl py-20 sm:py-24 mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 xlg:grid-cols-3 gap-8">
              {comparisonsData.map((card, index) => {
                return (
                  <Link
                    key={index}
                    className={` h-full rounded-3xl transition-all duration-500 ease-in-out border border-surface-dark group hover:bg-surface bg-white  overflow-hidden cursor-pointer`}
                    href={`/signature/alternatives${card.link}`}
                  >
                    <div className="rounded-t-lg h-[230px] sm:h-[270px] ">
                      <Image
                        alt="content"
                        className={`w-full h-full object-cover`}
                        src={`${BASE_ASSETS_URL}/v2/alternatives${card.image}`}
                        width={10}
                        height={10}
                      />
                    </div>
                    <div className="px-4 sm:px-6 py-6 sm:py-8 flex justify-between flex-col h-fit sm:h-64 gap-6 sm:gap-3 w-full">
                      <div className="w-full">
                        <h2 className="text-2xl font-semibold title-font text-black">
                          {card.title}
                        </h2>
                        <p className="text-base leading-relaxed text-gray-900">
                          {card.description}
                        </p>
                      </div>
                      <div className="w-full flex justify-start items-center">
                        <CLMLinkPrimaryArrow
                          buttonText="View Article"
                          buttonUrl={`/signature/alternatives${card.link}`}
                        />
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alternatives;
